module.exports = __webpack_public_path__ + "static/img/联系电话.c4e92abd.png";